import { render, staticRenderFns } from "./DispatchTransportProtoTable.vue?vue&type=template&id=579795e8&scoped=true&"
import script from "./DispatchTransportProtoTable.vue?vue&type=script&lang=js&"
export * from "./DispatchTransportProtoTable.vue?vue&type=script&lang=js&"
import style0 from "./DispatchTransportProtoTable.vue?vue&type=style&index=0&id=579795e8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "579795e8",
  null
  
)

export default component.exports